<template>
  <f7-page class="page-message">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>SỬA TIN {{ title_play_style(region, playStyle) }}</f7-nav-title>
    </f7-navbar>
    <f7-block class="mt-2 mb-1" inset>
      <f7-segmented raised tag="p">
        <f7-button class="button-medium" fill :color="is_parsed ? 'orange' : 'red'" @click.prevent="toggleParseMessage">
          {{ is_parsed ? 'TIN GỐC' : ((is_parsing) ? 'ĐANG LỌC...' : 'LỌC TIN') }}
        </f7-button>
        <f7-button class="button-medium" :fill="is_parsed" :color="(is_parsed) ? 'blue' : 'gray'" @click.prevent="checkMessage">
          {{ ((is_checking) ? '...' : 'KIỂM TRA') }}
        </f7-button>
        <f7-button class="button-medium" :fill="is_checked" :color="(is_checked) ? 'green' : 'gray'" @click.prevent="submitEditMessage">
          LƯU
        </f7-button>
      </f7-segmented>
      <p class="text-align-center" v-if="playStyle !== 'mb_ngan'">
        <label class="mr-2">
          <f7-radio name="n-syntax" :value="0" @change="changeSyntax(false)" :checked="!!form_submit.n_syntax ? false : true"></f7-radio>
          Kết hợp
        </label>
        <label class="mr-2">
          <f7-radio name="n-syntax" :value="1" @change="changeSyntax(true)" :checked="!!form_submit.n_syntax ? true : false"></f7-radio>
          Bắt buộc có n
        </label>
      </p>
    </f7-block>
    <f7-list class="mt-0 mb-1" inset>
      <f7-list-input
          input-id="msg-content"
          label="TIN NHẮN"
          type="textarea"
          resizable
          placeholder="Nhập nội dung"
          :value="form_submit.content_parsed"
          @input="form_submit.content_parsed = $event.target.value, is_checked = false"
      >
      </f7-list-input>
    </f7-list>
    <f7-block inset class="mt-0 mb-1">
      <p class="msg-error" v-if="!!parse_error">{{ parse_error }}</p>
    </f7-block>
    <f7-block strong inset v-if="!_.isEmpty(messages)" class="mt-0">
      <f7-row class="border-bottom-thin-solid font-bold pb-1">
        <f7-col>ĐÀI</f7-col>
        <f7-col>SỐ</f7-col>
        <f7-col>CÚ PHÁP</f7-col>
        <f7-col>{{ playStyle !== 'mb_ngan' ? 'ĐIỂM' : 'GIÁ TIỀN' }}</f7-col>
      </f7-row>
      <virtual-list style="height: 300px; overflow-y: auto;" :data-key="'uid'" :data-sources="messages" :data-component="itemComponent"/>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';
import VirtualList from 'vue-virtual-scroll-list'
import ItemNumberCommand from "@/components/ItemNumberCommand";

export default {
  components:{
    VirtualList
  },
  props     :{
    region   :String,
    playStyle:String,
    custId   :String,
    drawDate :String,
    message  :Object
  },
  data(){
    return {
      form_submit  :{
        message_id      :0,
        customer_id     :0,
        region          :'',
        drawdate        :'',
        play_style      :this.playStyle,
        content_original:'',
        content_parsed  :'',
        n_syntax        :false,
      },
      customers    :[],
      regions      :{
        mn:'Miền Nam',
        mb:'Miền Bắc',
        mt:'Miền Trung'
      },
      is_parsing   :false,
      is_parsed    :false,
      is_checked   :false,
      is_checking  :false,
      parse_error  :'',
      checked_data :{},
      fake_input   :null,
      itemComponent:ItemNumberCommand
    }
  },
  computed:{
    ...mapState(['user_info']),
    messages(){
      let msgs = [];
      this._.each(this.checked_data, (msg, idx) => {
        if(this.checked_data.length > 1){
          msgs.push({
            uid    :idx,
            label  :idx + 1,
            channel:null,
            number :null,
            command:null,
            point  :null,
            unit   :null,
            is_win :0
          });
        }

        this._.each(msg, (item, msg_idx) => {
          this._.each(item.numbers, (num, num_idx) => {
            msgs.push({
              uid    :idx + '_' + msg_idx + '_' + num_idx,
              label  :null,
              channel:item.channel,
              number :this._.isArray(num) ? num.join(' - ') : num,
              command:item.display_command,
              point  :item.point,
              unit   :this._.isUndefined(item.unit) ? '' : item.unit,
              is_win :0
            });
          });
        });
      });

      return msgs;
    }
  },
  methods :{
    toggleParseMessage(){
      if(this.is_parsing){
        return false;
      }
      if(this.form_submit.content_original === ''){
        this.form_submit.content_original = this.form_submit.content_parsed;
      }else{
        this.form_submit.content_parsed = this.form_submit.content_original;
        this.form_submit.content_original = '';
        this.is_parsed = false;
        this.is_checked = false;
        this.parse_error = '';
        return false;
      }

      if(this.form_submit.content_parsed === ''){
        this.$f7.dialog.alert('Vui lòng nhập tin nhắn', 'LỖI!');
        return false;
      }

      if(this.form_submit.drawdate === ''){
        this.$f7.dialog.alert('Vui lòng chọn ngày xổ', 'LỖI!');
        return false;
      }

      this.is_parsing = true;

      // this.$f7.dialog.preloader();
      // this.$f7.preloader.show();

      this.form_submit.content_parsed = this.form_submit.content_parsed.replace(/̀/mg, ' ');
      this.form_submit.content_parsed = this.form_submit.content_parsed.replace(/\r/mg, '');
      this.form_submit.content_parsed = this.form_submit.content_parsed.replace(/\n/mg, ' ');

        this.$store.dispatch('parseMessage', {
            play_style: this.form_submit.play_style,
            region: this.region,
            content: this.form_submit.content_parsed,
            customer_id: this.custId
        }).then((data) => {
            this.is_parsing = false;
            // this.$f7.dialog.close();
            // this.$f7.preloader.hide();
            this.form_submit.content_parsed = data;
            this.is_parsed = true;
        }).catch((err) => {
            this.is_parsing = false;
            // this.$f7.dialog.close();
            // this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
        })

        // if (this.form_submit.play_style === 'default') {
        //     this.form_submit.content_parsed = this.localParse(this.form_submit.content_parsed);
        //     this.is_parsing = false;
        //     this.is_parsed = true;
        // } else {
        //
        // }
    },
    checkMessage(){
      if(!this.is_parsed){
        return false;
      }

      this.is_checking = true;

      this.fake_input.focus();

      // this.$f7.dialog.preloader();
      // this.$f7.preloader.show();

        this.$store.dispatch('parseMessage', {
            play_style: this.form_submit.play_style,
            region: this.region,
            content: this.form_submit.content_parsed,
            customer_id: this.custId
        }).then((data) => {
            this.form_submit.content_parsed = data;

            return this.$store.dispatch('checkMessage', {
                content: this.form_submit.content_parsed,
                region: this.region,
                drawdate: this.form_submit.drawdate,
                n_syntax: this.form_submit.n_syntax,
                play_style: this.form_submit.play_style,
                customer_id: this.custId
            });
        }).then((data) => {
        this.is_checking = false;
        // this.$f7.dialog.close();
        // this.$f7.preloader.hide();
        this.is_checked = true;
        this.parse_error = '';
        this.checked_data = data.result;

        this.fake_input.blur();
      }).catch((err) => {
        this.is_checking = false;
        this.is_checked = false;
        this.checked_data = {};
        // this.$f7.dialog.close();
        // this.$f7.preloader.hide();
        this.parse_error = err.message;

        if(err.length > 0){
          document.getElementById('msg-content').focus();
          setTimeout(() => {
            let fullText = document.getElementById('msg-content').value;
            document.getElementById('msg-content').value = fullText.substring(0, err.index + err.length);
            document.getElementById('msg-content').scrollTop = document.getElementById('msg-content').scrollHeight;
            document.getElementById('msg-content').value = fullText;

            document.getElementById('msg-content').setSelectionRange(err.index, err.index + err.length)
          }, 200);
        }
      })
    },
    submitEditMessage(){
      if(!this.is_checked){
        return false;
      }

      this.fake_input.focus();

      this.form_submit.content_original = this.form_submit.content_parsed;

      this.$f7.preloader.show();
      // this.$f7.dialog.preloader();

      this.$store.dispatch('editMessage', this.form_submit).then(() => {
        this.$f7.preloader.hide();
        // this.$f7.dialog.close();
        // this.$f7.dialog.alert('LƯU TIN NHẮN THÀNH CÔNG', 'SUCCESS!');

        // this.is_parsed = false;
        // this.is_checked = false;

        this.parse_error = '';
        // this.form_submit.content_parsed = '';
        // this.form_submit.content_original = '';
        // this.checked_data = {};

        this.fake_input.blur();

        this.$f7router.back();
        // this.$f7.dialog.alert('LƯU TIN NHẮN THÀNH CÔNG', 'SUCCESS!', () => {
        //     this.$f7router.back();
        // });
      }).catch((err) => {
        this.$f7.preloader.hide();
        // this.$f7.dialog.close();
        this.parse_error = err.message;

        if(err.length > 0){
          document.getElementById('msg-content').focus();
          setTimeout(() => {
            let fullText = document.getElementById('msg-content').value;
            document.getElementById('msg-content').value = fullText.substring(0, err.index + err.length);
            document.getElementById('msg-content').scrollTop = document.getElementById('msg-content').scrollHeight;
            document.getElementById('msg-content').value = fullText;

            document.getElementById('msg-content').setSelectionRange(err.index, err.index + err.length)
          }, 200);
        }
      })
    },
    changeSyntax(val){
      this.form_submit.n_syntax = val;
      this.user_info.user_configs.n_syntax = val;

      this.$store.dispatch('changeMeConfig', this.user_info.user_configs).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    }
  },
  mounted(){
    this.form_submit.message_id = this.message.id;
    this.form_submit.customer_id = this.custId;
    this.form_submit.region = this.region;
    this.form_submit.drawdate = this.drawDate;
    this.form_submit.content_parsed = this.message.content;

    this.fake_input = document.createElement('input')
    this.fake_input.setAttribute('type', 'text')
    this.fake_input.style.position = 'absolute'
    this.fake_input.style.opacity = 0
    this.fake_input.style.height = 0
    this.fake_input.style.fontSize = '16px' // disable auto zoom

    this.form_submit.n_syntax = this.user_info.user_configs.n_syntax;

    document.body.prepend(this.fake_input)
  },
  detroyed(){
    this.fake_input.remove();
  }
};
</script>
<style scoped>
.msg-error {
  color : red;
}
</style>
